<form class="form-group">
  <label class="form-control-label text-break">{{model.title}}</label>
</form>
